function swymCallbackFn(swat) {
    function swymAttachEvents() {
      swat.initializeActionButtons("div.fancybox-container");
    }
    document.addEventListener("quickview:loaded", function (e) {
      swymAttachEvents();
    });
  }
  
  let oldWishlistName = "";
  
  // Initialize global variables
  let themeGlobalSwat = "";
  let globalListArray = [];
  let currentVariantId = "";
  let wishlistCurrentProduct = null;
  let wishlistCurrentSwatchData = null;

  const WISHLIST_COLOR_LABELS = ["color", "colour", "couleur"];

  function getUniqueOptionValues(product, position) {
    const key = `option${position}`;
    return [
      ...new Set(
        (product?.variants || [])
          .map((variant) => variant[key])
          .filter((value) => value != null && value !== "")
      ),
    ];
  }

  function getProductOptions(product) {
    if (!product?.options?.length) return [];

    const firstOption = product.options[0];

    if (typeof firstOption === "string") {
      return product.options
        .map((name, index) => ({
          name,
          position: index + 1,
          values: getUniqueOptionValues(product, index + 1),
        }))
        .filter((option) => option.values.length > 0);
    }

    if (firstOption?.name) {
      return product.options
        .map((option, index) => ({
          name: option.name,
          position: index + 1,
          values:
            option.values?.length > 0
              ? option.values
              : getUniqueOptionValues(product, index + 1),
        }))
        .filter((option) => option.values.length > 0);
    }

    return [];
  }

  function isWishlistColorOption(optionName) {
    const normalized = String(optionName || "").toLowerCase();
    return WISHLIST_COLOR_LABELS.some((label) => normalized.includes(label));
  }

  function getWishlistSelectedOptions(wrapper) {
    const selections = {};

    wrapper.querySelectorAll(".wishlist-option-group").forEach((group) => {
      const position = parseInt(group.dataset.optionPosition, 10);
      const selected = group.querySelector(".variant-options.selected");
      if (selected) selections[position] = selected.dataset.optionValue;
    });

    return selections;
  }

  function getOptionValueState(product, position, value, selections) {
    const matchingVariants = (product.variants || []).filter((variant) => {
      for (let i = 1; i < position; i++) {
        const selected = selections[i];
        if (selected && variant[`option${i}`] !== selected) return false;
      }
      return variant[`option${position}`] === value;
    });

    if (!matchingVariants.length) return "unavailable";
    if (matchingVariants.some((variant) => variant.available)) return "available";
    return "sold-out";
  }

  function findWishlistVariant(product, selections) {
    const options = getProductOptions(product);
    if (!options.length || options.some((option) => !selections[option.position])) {
      return null;
    }

    return (
      product.variants.find((variant) =>
        options.every(
          (option) => variant[`option${option.position}`] === selections[option.position]
        )
      ) || null
    );
  }

  function applyWishlistSwatchStyle(button, swatchImageUrl, label) {
    button.classList.add("is-swatch");

    if (swatchImageUrl) {
      button.style.backgroundColor = "transparent";
      button.style.backgroundImage = `url(${swatchImageUrl})`;
      button.style.backgroundSize = "cover";
      button.style.backgroundPosition = "center";
      button.style.backgroundRepeat = "no-repeat";
      button.setAttribute("aria-label", label);
      button.innerHTML = "";
      return;
    }

    button.style.backgroundImage = "";
    button.style.backgroundColor = "";
    button.removeAttribute("aria-label");
    button.innerHTML = `<span>${label}</span>`;
  }

  function getWishlistColorSwatchUrl(swatchData, value, product, optionPosition) {
    if (swatchData?.color_swatches?.[value]) {
      return swatchData.color_swatches[value];
    }

    const swatchVariant = product.variants.find(
      (variant) =>
        variant[`option${optionPosition}`] === value && variant.featured_image
    );

    return swatchVariant?.featured_image?.src || "";
  }

  function getDefaultWishlistSelections(product, swatchData = wishlistCurrentSwatchData) {
    const selections = {};

    getProductOptions(product).forEach((option) => {
      const isColor = isWishlistColorOption(option.name);

      if (
        isColor &&
        swatchData?.has_combined_swatches &&
        swatchData.combined_products?.length
      ) {
        const currentCombined = swatchData.combined_products.find(
          (combined) => combined.handle === product.handle || combined.is_current
        );

        if (currentCombined) {
          selections[option.position] = currentCombined.color;
          return;
        }
      }

      const availableValue = option.values.find(
        (value) =>
          getOptionValueState(product, option.position, value, selections) ===
          "available"
      );

      if (availableValue) {
        selections[option.position] = availableValue;
        return;
      }

      const fallbackValue = option.values.find(
        (value) =>
          getOptionValueState(product, option.position, value, selections) !==
          "unavailable"
      );

      if (fallbackValue) selections[option.position] = fallbackValue;
    });

    return selections;
  }

  function applyWishlistSelections(product, wrapper, selections) {
    const options = getProductOptions(product);

    options.forEach((option) => {
      const group = wrapper.querySelector(
        `[data-option-position="${option.position}"]`
      );
      if (!group) return;

      const selectedValue = selections[option.position] || "";
      const labelValue = group.querySelector(".wishlist-option-selected-value");
      const isCombinedColorGroup = group.classList.contains(
        "wishlist-option-group--combined"
      );

      if (isCombinedColorGroup) {
        const currentCombined = wishlistCurrentSwatchData?.combined_products?.find(
          (combined) => combined.handle === product.handle
        );
        if (labelValue) {
          labelValue.textContent = currentCombined?.color || selectedValue;
        }
      } else if (labelValue) {
        labelValue.textContent = selectedValue;
      }

      group.querySelectorAll(".variant-options").forEach((button) => {
        const value = button.dataset.optionValue;

        if (isCombinedColorGroup) {
          button.classList.toggle(
            "selected",
            button.dataset.combinedHandle === product.handle
          );
          button.classList.remove("is-unavailable", "is-sold-out");
          button.disabled = false;
          return;
        }

        const state = getOptionValueState(product, option.position, value, selections);

        button.classList.toggle("selected", value === selectedValue);
        button.classList.toggle("is-unavailable", state === "unavailable");
        button.classList.toggle("is-sold-out", state === "sold-out");
        button.disabled = state === "unavailable" || state === "sold-out";
      });
    });

    const variant = findWishlistVariant(product, selections);
    currentVariantId = variant?.id ? String(variant.id) : "";

    const wishlistDom = wrapper.closest(".wishlist-variant");
    if (variant && wishlistDom) {
      selectWishlistGalleryImage(
        wishlistDom,
        getWishlistVariantImageIndex(product, variant)
      );
    }

    isVariantPresentInLists();
  }

  async function switchWishlistCombinedProduct(handle, wrapper) {
    const wishlistDom = wrapper.closest(".wishlist-variant");
    if (!wishlistDom || !handle || handle === wishlistCurrentProduct?.handle) {
      return;
    }

    const [product, swatchData] = await Promise.all([
      getProductById(handle),
      getWishlistSwatchData(handle),
    ]);

    if (!product) return;

    wishlistCurrentSwatchData = swatchData;
    await updateWishlistProductUI(wishlistDom, product);
    refreshWishlistGalleryAfterShow(wishlistDom);
    buildWishlistVariantPicker(
      product,
      wrapper,
      swatchData
    );
  }

  async function onWishlistOptionSelect(product, wrapper, position, value, button) {
    const combinedHandle = button?.dataset?.combinedHandle;

    if (combinedHandle && combinedHandle !== product.handle) {
      await switchWishlistCombinedProduct(combinedHandle, wrapper);
      return;
    }

    const selections = getWishlistSelectedOptions(wrapper);
    selections[position] = value;

    const options = getProductOptions(product);
    const changedIndex = options.findIndex((option) => option.position === position);

    for (let i = changedIndex + 1; i < options.length; i++) {
      const option = options[i];
      const currentValue = selections[option.position];
      const currentState = currentValue
        ? getOptionValueState(product, option.position, currentValue, selections)
        : "unavailable";

      if (currentState === "unavailable" || currentState === "sold-out") {
        const nextValue = option.values.find(
          (optionValue) =>
            getOptionValueState(product, option.position, optionValue, selections) ===
            "available"
        );

        if (nextValue) selections[option.position] = nextValue;
        else delete selections[option.position];
      }
    }

    applyWishlistSelections(product, wrapper, selections);
  }

  function buildWishlistVariantPicker(product, wrapper, swatchData = wishlistCurrentSwatchData) {
    wrapper.innerHTML = "";
    wishlistCurrentProduct = product;
    wishlistCurrentSwatchData = swatchData;
    currentVariantId = "";

    if (!product?.variants?.length) return;

    const options = getProductOptions(product);
    const hasCombinedSwatches =
      swatchData?.has_combined_swatches && swatchData.combined_products?.length > 0;
    const hasMultipleVariants =
      product.variants.length > 1 &&
      !(
        options.length === 1 &&
        options[0].values.length <= 1
      );

    if (!hasMultipleVariants && !hasCombinedSwatches) {
      currentVariantId = String(product.variants[0].id);
      isVariantPresentInLists();
      return;
    }

    options.forEach((option) => {
      const isColor = isWishlistColorOption(option.name);
      const group = document.createElement("div");
      group.className = `wishlist-option-group${
        isColor ? " wishlist-option-group--color" : ""
      }`;
      group.dataset.optionPosition = String(option.position);

      if (isColor && hasCombinedSwatches) {
        group.classList.add("wishlist-option-group--combined");
      }

      const label = document.createElement("div");
      label.className = "wishlist-option-label";
      label.innerHTML = `${option.name}: <span class="wishlist-option-selected-value"></span>`;
      group.appendChild(label);

      const values = document.createElement("div");
      values.className = "wishlist-option-values";

      if (isColor && hasCombinedSwatches) {
        swatchData.combined_products.forEach((combined) => {
          const button = document.createElement("button");
          button.type = "button";
          button.className = "variant-options";
          button.dataset.optionPosition = String(option.position);
          button.dataset.optionValue = combined.color;
          button.dataset.combinedHandle = combined.handle;
          applyWishlistSwatchStyle(button, combined.swatch_image, combined.color);
          values.appendChild(button);
        });
      } else {
        option.values.forEach((value) => {
          const button = document.createElement("button");
          button.type = "button";
          button.className = "variant-options";
          button.dataset.optionPosition = String(option.position);
          button.dataset.optionValue = value;

          if (isColor) {
            const swatchUrl = getWishlistColorSwatchUrl(
              swatchData,
              value,
              product,
              option.position
            );
            applyWishlistSwatchStyle(button, swatchUrl, value);
          } else {
            button.innerHTML = `<span>${value}</span>`;
          }

          values.appendChild(button);
        });
      }

      group.appendChild(values);
      wrapper.appendChild(group);
    });

    applyWishlistSelections(
      product,
      wrapper,
      getDefaultWishlistSelections(product, swatchData)
    );
  }

  function getWishlistSelectedVariantPayload() {
    if (!currentVariantId || !wishlistCurrentProduct) return null;

    return {
      epi: currentVariantId,
      empi: wishlistCurrentProduct.id,
      du: shopUrl + wishlistCurrentProduct.url,
    };
  }
  
  // Cache for fetchLists to prevent multiple calls
  let fetchListsCache = {
    promise: null,
    data: null,
    timestamp: null,
    CACHE_DURATION: 30000 // 30 seconds cache duration
  };
  
  // Centralized function to fetch lists with caching
  function fetchListsWithCache(callbackFn, errorFn, forceRefresh = false) {
    const now = Date.now();
    
    // Check if we have valid cached data and not forcing refresh
    if (!forceRefresh && 
        fetchListsCache.data && 
        fetchListsCache.timestamp && 
        (now - fetchListsCache.timestamp) < fetchListsCache.CACHE_DURATION) {
      // Return cached data immediately
      if (callbackFn) {
        callbackFn(fetchListsCache.data);
      }
      return Promise.resolve(fetchListsCache.data);
    }
    
    // If there's already a pending request, return that promise
    if (fetchListsCache.promise) {
      return fetchListsCache.promise.then(data => {
        if (callbackFn) {
          callbackFn(data);
        }
        return data;
      }).catch(error => {
        if (errorFn) {
          errorFn(error);
        }
        throw error;
      });
    }
    
    // Create new request
    fetchListsCache.promise = new Promise((resolve, reject) => {
      themeGlobalSwat.fetchLists({
        callbackFn: function(lists) {
          // Update cache
          fetchListsCache.data = lists;
          fetchListsCache.timestamp = now;
          fetchListsCache.promise = null;
          
          // Call the provided callback
          if (callbackFn) {
            callbackFn(lists);
          }
          
          resolve(lists);
        },
        errorFn: function(error) {
          // Clear promise on error
          fetchListsCache.promise = null;
          
          // Call the provided error callback
          if (errorFn) {
            errorFn(error);
          }
          
          reject(error);
        }
      });
    });
    
    return fetchListsCache.promise;
  }
  
  // Function to invalidate cache (call when lists are modified)
  function invalidateFetchListsCache() {
    fetchListsCache.promise = null;
    fetchListsCache.data = null;
    fetchListsCache.timestamp = null;
  }
  
  // Initialize Swym callbacks
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  
  window.SwymCallbacks.push(function (swat) {
    themeGlobalSwat = swat;
    updateGlobalListArray();
    persistWishlistButtonsState();
  });
  
  const overlay = document.body.querySelector(".cart-black-overlay-wl");
  
  overlay.addEventListener("click", function (event) {
    fadeOut();
    const wishlistVariant = document.body.querySelector(".wishlist-variant");
    if (
      wishlistVariant &&
      wishlistVariant.classList.contains("wishlist-variant")
    ) {
      wishlistVariant.querySelectorAll(".variant-options").forEach((x, i) => {
        x.classList.remove("selected");
      });
      fadeOut();
      document.documentElement.classList.remove("no-scroll");
      resetWishlistProductGallery(wishlistVariant);
      wishlistVariant.querySelector(".product-title").innerHTML = "NN";
      wishlistVariant.querySelector(".options-wrapper").innerHTML = "";
      wishlistVariant.querySelector(".existing-wishlist-select").innerHTML = "";
      wishlistVariant.classList.remove("show");
      resetWishlistAddForm(wishlistVariant);
      wishlistCurrentProduct = null;
      currentVariantId = "";
    }
  });
  
  function fadeIn() {
    overlay.style.display = "block"; // Make it visible
    setTimeout(() => {
      overlay.classList.add("show"); // Start the transition
    }, 10); // Slight delay to allow the transition to apply
  }
  
  function fadeOut() {
    overlay.style.display = "none"; // Hide after the transition
    setTimeout(() => {
      overlay.classList.remove("show"); // Start fading out
    });
  }
  
  const overlayLoading = document.body.querySelector(".wishlist-loader");
  
  function loadingFadeIn() {
    setTimeout(() => {
      overlayLoading.classList.add("show"); // Start the transition
    }, 1); // Slight delay to allow the transition to apply
  }
  
  function loadingFadeOut() {
    setTimeout(() => {
      overlayLoading.classList.remove("show"); // Start fading out
    }, 2000);
  }
  
  // Check if themeGlobalSwat is null or empty and invoke SwymCallbacks if it is
  async function checkAndInvokeSwymCallbacks() {
    if (!themeGlobalSwat) {
      await window.SwymCallbacks.push(function (swat) {
        themeGlobalSwat = swat;
        updateGlobalListArray();
        persistWishlistButtonsState();
      });
    }
  }
  
  // Check if a variant is present in the lists
  function isVariantPresentInLists() {
    globalListArray.forEach((list) => {
      const listId = list.lid;
      const listInput = document.querySelector(
        `.existing-wishlist-select .option[data-productvalue="${listId}"] button`
      );
  
      const variantIsPresent =
        listInput &&
        list.listcontents.some(
          (variant) => variant.epi.toString() === currentVariantId
        );
  
      if(listInput) {
        listInput?.setAttribute("variantexistsinlist", variantIsPresent);
        listInput.innerHTML = variantIsPresent ? "Remove" : "Add";
      }
      
      if (listInput && variantIsPresent) {
        listInput?.classList.add("button-wishlish-remove-product");
        listInput?.classList.remove("button-wishlish-add-product");
      } else {
        listInput?.classList.remove("button-wishlish-remove-product");
        listInput?.classList.add("button-wishlish-add-product");
      }
    });
  }
  
  function persistWishlistButtonsState() {
    return new Promise((resolve, reject) => {
      let onSuccess = function (lists) {
        globalListArray = lists;
        let buttons = document.querySelectorAll("button.button-wishlish-click");
        let productIds = [];
  
        let ctr = 0;
        lists.forEach((list) => {
          list.listcontents.forEach((product) => {
            let productId = product.empi;
            productIds.push(productId);
          });
          ctr++;
          if (ctr === lists.length) {
            buttons.forEach((button) => {
              let productId = button.getAttribute("data-product-id");
              if (productIds.includes(parseInt(productId))) {
                SwymUtils.addClass(button, "swym-added");
              } else {
                SwymUtils.removeClass(button, "swym-added");
              }
            });
          }
        });
  
        resolve();
      };
  
      let onError = function (error) {
        console.error("Error while fetching all Lists", error);
        reject(error);
      };
  
      fetchListsWithCache(onSuccess, onError);
    });
  }
  
  // Update the global list array
  function updateGlobalListArray() {
    fetchListsWithCache(
      function (lists) {
        globalListArray = lists;
        isVariantPresentInLists();
        persistWishlistButtonsState();
      },
      function (error) {
        console.log("Error while fetching all Lists", error);
      }
    );
  }
  
  // Handle click events on the document body
  document.body.addEventListener("click", function (event) {
    // Handle variant option selection
    if (event.target.closest(".variant-options")) {
      const button = event.target.closest(".variant-options");
      if (!button || button.disabled) return;

      const wrapper = button.closest(".options-wrapper");
      if (!wrapper || !wishlistCurrentProduct) return;

      const position = parseInt(button.dataset.optionPosition, 10);
      const value = button.dataset.optionValue;
      if (!position || !value) return;

      onWishlistOptionSelect(
        wishlistCurrentProduct,
        wrapper,
        position,
        value,
        button
      );
    }
  
    // Handle adding a product to the wishlist
    if (event.target.classList.contains("button-wishlish-add-product")) {
      const selectedVariant = getWishlistSelectedVariantPayload();
      let lid = event.target.parentNode.getAttribute("data-productvalue");

      if (!selectedVariant) {
        Toastify({
          text: "Please select a product variant.",
          duration: 3000,
          close: true,
          style: {
            background: "#000",
          },
        }).showToast();
        return;
      }
  
       // Store original button text and disable button
       const button = event.target;
       const originalText = button.textContent;
       button.innerHTML = '<svg class="loading-spinner" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416"><animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/><animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/></circle></svg>';
       button.disabled = true;
       button.style.opacity = "0.7";
       button.style.cursor = "not-allowed";
  
      let onSuccess = async function (addedListItem) {
        // Restore button state
        button.textContent = originalText;
        button.disabled = false;
        button.style.opacity = "1";
        button.style.cursor = "pointer";
  
        // Invalidate cache and refresh data
        invalidateFetchListsCache();
        updateGlobalListArray();
        persistWishlistButtonsState();
        Toastify({
          text: "Product added to wishlist",
          duration: 3000,
          close: true,
          style: {
            background: "#000",
          },
        }).showToast();
      };
  
      let onError = function (error) {
        // Restore button state on error
        button.textContent = originalText;
        button.disabled = false;
        button.style.opacity = "1";
        button.style.cursor = "pointer";
        
        console.log("Error while removing the Product from the List", error);
        Toastify({
          text: "Error removing product from wishlist",
          duration: 3000,
          close: true,
          style: {
            background: "#ff0000",
          },
        }).showToast();
      };
  
      themeGlobalSwat.addToList(lid, selectedVariant, onSuccess, onError);
    }
  
    // Handle removing a product from the wishlist
    if (event.target.classList.contains("button-wishlish-remove-product")) {
      const selectedVariant = getWishlistSelectedVariantPayload();
      let lid = event.target.parentNode.getAttribute("data-productvalue");

      if (!selectedVariant) {
        Toastify({
          text: "Please select a product variant.",
          duration: 3000,
          close: true,
          style: {
            background: "#000",
          },
        }).showToast();
        return;
      }
  
      // Store original button text and disable button
      const button = event.target;
      const originalText = button.textContent;
      button.innerHTML = '<svg class="loading-spinner" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416"><animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/><animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/></circle></svg>';
      button.disabled = true;
      button.style.opacity = "0.7";
      button.style.cursor = "not-allowed";
  
      let onSuccess = async function (addedListItem) {
        
        // Restore button state
        button.textContent = originalText;
        button.disabled = false;
        button.style.opacity = "1";
        button.style.cursor = "pointer";
  
        // Invalidate cache and refresh data
        invalidateFetchListsCache();
        updateGlobalListArray();
        persistWishlistButtonsState();
        Toastify({
          text: "Product removed from wishlist",
          duration: 3000,
          close: true,
          style: {
            background: "#000",
          },
        }).showToast();
      };
  
      let onError = function (error) {
        // Restore button state on error
        button.textContent = originalText;
        button.disabled = false;
        button.style.opacity = "1";
        button.style.cursor = "pointer";
        
        console.log("Error while adding the Product to the List", error);
        Toastify({
          text: "Error adding product to wishlist",
          duration: 3000,
          close: true,
          style: {
            background: "#ff0000",
          },
        }).showToast();
      };
  
      themeGlobalSwat.deleteFromList(lid, selectedVariant, onSuccess, onError);
    }
  });
  
  // Success callback for fetching lists
  let onSuccessGetList = function (lists, select) {
    select.innerHTML = "";
    lists.forEach((x, i) => {
      let option = `<div role="button" class="option" data-productvalue="${x?.lid}">
              <span class="option-name">${x?.lname}</span>
              <button type="button" class="button button--primary button--sm button-option button-wishlish-add-product">Add</button>
              </div>`;
      select.insertAdjacentHTML("beforeend", option);
    });
  
    return lists;
  };
  
  // Error callback for fetching lists
  let onErrorGetList = function (error) {
    console.log("Error while fetching all Lists", error);
  };
  
  // Fetch all existing wishlist items
  function getAllExistingWishlistItems(select) {
    return fetchListsWithCache(
      (lists) => onSuccessGetList(lists, select),
      onErrorGetList
    );
  }
  
  // Success callback for creating a wishlist
  let onSuccessCreateWishlist = function (
    newList,
    input,
    select,
    successMessage
  ) {
    // Invalidate cache and refresh data
    invalidateFetchListsCache();
    getAllExistingWishlistItems(select);
    updateGlobalListArray();
    hideWishlistAddForm(select);
    if (successMessage) {
      Toastify({
        text: "Wishlist added successfully",
        duration: 3000,
        close: true,
        style: {
          background: "#000",
        },
      }).showToast();
    }
  };
  
  // Error callback for creating a wishlist
  let onErrorCreateWishlist = function (error) {
    console.log("Error while creating a List", error);
  };
  
  // Create a new wishlist
  function createWishlist(
    input,
    name,
    select,
    noExistingWishlist = false,
    successMessage = true
  ) {
    if (noExistingWishlist) {
      if (globalListArray.length > 0) {
        return;
      }
    }
    let listConfig = {
      lname: name,
    };
  
    if(oldWishlistName !== name) {
      oldWishlistName = name;
    } else {
      return;
    }
  
    themeGlobalSwat.createList(
      listConfig,
      (lists) => onSuccessCreateWishlist(lists, input, select, successMessage),
      onErrorCreateWishlist
    );
  }
  
  function getWishlistAddFormRoot(element) {
    return element?.closest(".existing-wishlist") || document.querySelector(".existing-wishlist");
  }

  function hideWishlistAddForm(root) {
    const wishlistRoot = getWishlistAddFormRoot(root);
    if (!wishlistRoot) return;

    const form = wishlistRoot.querySelector(".existing-wishlist-select-add-form");
    const select = wishlistRoot.querySelector(".existing-wishlist-select");
    const enableButton = wishlistRoot.querySelector(".existing-wishlist-button-enable");
    const input = wishlistRoot.querySelector("input.new-wishlist-name");

    if (form) {
      form.classList.add("hide");
      form.classList.remove("show");
    }

    if (select) {
      select.classList.remove("hide");
    }

    if (enableButton) {
      enableButton.classList.remove("hide");
    }

    if (input) {
      input.value = "";
    }
  }

  function showWishlistAddForm(root) {
    const wishlistRoot = getWishlistAddFormRoot(root);
    if (!wishlistRoot) return;

    const form = wishlistRoot.querySelector(".existing-wishlist-select-add-form");
    const select = wishlistRoot.querySelector(".existing-wishlist-select");
    const enableButton = wishlistRoot.querySelector(".existing-wishlist-button-enable");
    const input = wishlistRoot.querySelector("input.new-wishlist-name");

    if (select) {
      select.classList.add("hide");
    }

    if (form) {
      form.classList.remove("hide");
      form.classList.add("show");
    }

    if (enableButton) {
      enableButton.classList.add("hide");
    }

    if (input) {
      input.focus();
    }
  }

  function resetWishlistAddForm(root) {
    hideWishlistAddForm(root);
  }

  // Handle click events on existing wishlist buttons
  const addNewWishlistButton = document.querySelectorAll(
    ".existing-wishlist-button-add"
  );
  
  function isListNameAlreadyExists(name) {
    return globalListArray.some((list) => list.lname === name);
  }
  
  addNewWishlistButton.forEach((button) => {
    button.addEventListener("click", async function () {
      const wishlistRoot = getWishlistAddFormRoot(button);
      let input = wishlistRoot.querySelector("input.new-wishlist-name");
      let inputName = input.value;
  
      if(!(inputName.length > 2 && inputName.length < 50)) {
        Toastify({
          text: "Please enter a wishlist name between 3 and 50 characters.",
          duration: 3000,
          close: true,
          style: {
            background: "#000",
          },
        }).showToast();
        return;
      }
  
      let isExists = await isListNameAlreadyExists(inputName);
  
      if (!inputName || isExists) {
        Toastify({
          text: isExists
            ? "Please choose a different wishlist name."
            : "Please enter a wishlist name.",
          duration: 3000,
          close: true,
          style: {
            background: "#000",
          },
        }).showToast();
        return;
      }
  
      createWishlist(
        input,
        inputName,
        wishlistRoot.querySelector(".existing-wishlist-select")
      );
    });
  });
  
  // Handle click events on existing wishlist buttons
  const addNewWishlistButtonCancel = document.querySelectorAll(
    ".existing-wishlist-button-cancel"
  );
  
  addNewWishlistButtonCancel.forEach((button) => {
    button.addEventListener("click", function () {
      hideWishlistAddForm(button);
    });
  });
  
  // Handle click events on existing wishlist buttons
  const addNewWishlistEnable = document.querySelectorAll(
    ".existing-wishlist-button-enable"
  );
  
  addNewWishlistEnable.forEach((button) => {
    button.addEventListener("click", function () {
      showWishlistAddForm(button);
    });
  });
  
  // Handle click events on wishlist close buttons
  const wishlistCloseButtons = document.querySelectorAll(
    ".wishlist-variant__close"
  );
  
  wishlistCloseButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const wishlistVariant = button.closest(".wishlist-variant");
      if (
        wishlistVariant &&
        wishlistVariant.classList.contains("wishlist-variant")
      ) {
        wishlistVariant.querySelectorAll(".variant-options").forEach((x, i) => {
          x.classList.remove("selected");
        });
        fadeOut();
        document.documentElement.classList.remove("no-scroll");
        resetWishlistProductGallery(wishlistVariant);
        wishlistVariant.querySelector(".product-title").innerHTML = "NN";
        wishlistVariant.querySelector(".options-wrapper").innerHTML = "";
        wishlistVariant.querySelector(".existing-wishlist-select").innerHTML = "";
        wishlistVariant.classList.remove("show");
        resetWishlistAddForm(wishlistVariant);
        wishlistCurrentProduct = null;
        wishlistCurrentSwatchData = null;
        currentVariantId = "";
      }
    });
  });

  let wishlistGalleryCarouselListener = null;

  function getWishlistGalleryElements(wishlistDom) {
    return {
      carousel: wishlistDom.querySelector("#wishlist-product-gallery-carousel"),
      dots: wishlistDom.querySelector("[data-wishlist-gallery-dots]"),
      prevButton: wishlistDom.querySelector(
        'carousel-prev-button[aria-controls="wishlist-product-gallery-carousel"] button'
      ),
      nextButton: wishlistDom.querySelector(
        'carousel-next-button[aria-controls="wishlist-product-gallery-carousel"] button'
      ),
    };
  }

  function syncWishlistGalleryArrows(wishlistDom) {
    const { carousel, prevButton, nextButton } = getWishlistGalleryElements(wishlistDom);
    if (!carousel || !prevButton || !nextButton) return;

    const cellCount = carousel.cells?.length || 0;
    const isScrollable = cellCount > 1 && carousel.scrollWidth > carousel.clientWidth;
    const index = Math.max(0, carousel.selectedIndex || 0);

    carousel.classList.toggle("is-scrollable", isScrollable);
    prevButton.disabled = !isScrollable || index <= 0;
    nextButton.disabled = !isScrollable || index >= cellCount - 1;
  }

  function syncWishlistGalleryDots(wishlistDom, activeIndex) {
    const { dots } = getWishlistGalleryElements(wishlistDom);
    dots?.querySelectorAll(".tap-area").forEach((button, index) => {
      button.setAttribute("aria-current", index === activeIndex ? "true" : "false");
    });
  }

  function getWishlistProductImages(product) {
    const images = (product?.images || [])
      .map((image) => (typeof image === "string" ? image : image?.src))
      .filter(Boolean);

    if (images.length) return images;

    const featured = product?.featured_image?.src || product?.featured_image;
    return featured ? [featured] : [];
  }

  function getWishlistVariantImageIndex(product, variant) {
    const images = getWishlistProductImages(product);
    if (!images.length || !variant?.featured_image) return 0;

    const variantSrc = variant.featured_image.src || variant.featured_image;
    const index = images.indexOf(variantSrc);
    return index >= 0 ? index : 0;
  }

  function refreshWishlistGalleryCarousel(carousel) {
    if (!carousel) return;

    carousel.style.maxHeight = "";

    requestAnimationFrame(() => {
      carousel.dispatchEvent(
        new CustomEvent("carousel:settle", {
          detail: {
            index: carousel.selectedIndex,
            cell: carousel.selectedCell,
          },
        })
      );

      const wishlistDom = carousel.closest(".wishlist-variant");
      if (wishlistDom) syncWishlistGalleryArrows(wishlistDom);
    });
  }

  function refreshWishlistGalleryAfterShow(wishlistDom) {
    const carousel = wishlistDom?.querySelector("#wishlist-product-gallery-carousel");
    if (!carousel?.cells?.length) return;

    carousel.style.maxHeight = "";

    const activeIndex = Math.max(0, carousel.selectedIndex || 0);

    carousel.cells.forEach((cell) => {
      const mediaWrap = cell.querySelector(".wishlist-gallery-media");
      const img = mediaWrap?.querySelector(".wishlist-gallery-media__image");

      if (!mediaWrap || !img) return;

      preloadWishlistGalleryCellImage(cell);

      if (img.complete && img.naturalHeight > 0) {
        markWishlistGalleryImageLoaded(mediaWrap, carousel);
      }
    });

    preloadWishlistGalleryAdjacentImages(carousel, activeIndex);

    requestAnimationFrame(() => {
      if (typeof carousel.select === "function") {
        carousel.select(activeIndex, { instant: true });
      }

      syncWishlistGalleryDots(wishlistDom, activeIndex);
      refreshWishlistGalleryCarousel(carousel);
      window.dispatchEvent(new Event("resize"));
    });
  }

  function preloadWishlistGalleryCellImage(cell) {
    const img = cell?.querySelector(".wishlist-gallery-media__image");
    const src = img?.dataset?.src;
    if (!img || !src) return;

    if (img.loading === "lazy") {
      img.loading = "eager";
    }

    if (!img.getAttribute("src")) {
      img.src = src;
    }
  }

  function preloadWishlistGalleryAdjacentImages(carousel, index) {
    if (!carousel?.cells?.length) return;

    [index - 1, index, index + 1]
      .filter((i) => i >= 0 && i < carousel.cells.length)
      .forEach((i) => preloadWishlistGalleryCellImage(carousel.cells[i]));
  }

  function markWishlistGalleryImageLoaded(mediaWrap, carousel) {
    if (!mediaWrap || mediaWrap.classList.contains("is-loaded")) return;

    mediaWrap.classList.remove("is-loading");
    mediaWrap.classList.add("is-loaded");
    refreshWishlistGalleryCarousel(carousel);
  }

  function createWishlistGalleryMedia(src, alt, { eager = false, carousel } = {}) {
    const mediaWrap = document.createElement("div");
    mediaWrap.className = "wishlist-gallery-media is-loading";

    const skeleton = document.createElement("div");
    skeleton.className = "wishlist-gallery-media__skeleton";
    skeleton.setAttribute("aria-hidden", "true");

    const img = document.createElement("img");
    img.className = "wishlist-gallery-media__image";
    img.alt = alt || "";
    img.decoding = "async";
    img.dataset.src = src;

    if (eager) {
      img.loading = "eager";
      img.setAttribute("fetchpriority", "high");
    } else {
      img.loading = "lazy";
    }

    const errorMessage = document.createElement("p");
    errorMessage.className = "wishlist-gallery-media__error";
    errorMessage.textContent = "Image could not be loaded";

    const handleLoad = () => markWishlistGalleryImageLoaded(mediaWrap, carousel);
    const handleError = () => {
      mediaWrap.classList.remove("is-loading");
      mediaWrap.classList.add("is-error");
      refreshWishlistGalleryCarousel(carousel);
    };

    img.addEventListener("load", handleLoad, { once: true });
    img.addEventListener("error", handleError, { once: true });

    mediaWrap.appendChild(skeleton);
    mediaWrap.appendChild(img);
    mediaWrap.appendChild(errorMessage);

    if (eager) {
      img.src = src;

      const tryReveal = () => {
        if (img.naturalHeight > 0) {
          handleLoad();
        }
      };

      if (img.complete) {
        tryReveal();
      }

      if (typeof img.decode === "function") {
        img.decode().then(tryReveal).catch(() => {});
      }
    }

    return mediaWrap;
  }

  function preloadWishlistImage(src) {
    return new Promise((resolve) => {
      if (!src) {
        resolve(false);
        return;
      }

      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = src;
    });
  }

  function selectWishlistGalleryImage(wishlistDom, index) {
    const { carousel } = getWishlistGalleryElements(wishlistDom);
    if (!carousel?.cells?.length) return;

    const safeIndex = Math.max(0, Math.min(index, carousel.cells.length - 1));

    preloadWishlistGalleryAdjacentImages(carousel, safeIndex);

    if (typeof carousel.select === "function") {
      carousel.select(safeIndex, { instant: false });
    }

    syncWishlistGalleryDots(wishlistDom, safeIndex);
    refreshWishlistGalleryCarousel(carousel);
  }

  async function buildWishlistProductGallery(wishlistDom, product, selectedIndex = 0) {
    const { carousel, dots } = getWishlistGalleryElements(wishlistDom);
    if (!carousel || !dots) return;

    const images = getWishlistProductImages(product);
    carousel.innerHTML = "";
    dots.innerHTML = "";

    if (!images.length) return;

    dots.hidden = images.length <= 1;
    const initialIndex = Math.max(0, Math.min(selectedIndex, images.length - 1));

    await preloadWishlistImage(images[initialIndex]);

    images.forEach((src, index) => {
      const media = document.createElement("div");
      media.className = `product-gallery__media snap-center${
        index === initialIndex ? " is-initial" : ""
      }`;
      media.dataset.mediaType = "image";
      media.dataset.mediaPosition = String(index + 1);
      media.setAttribute("role", "group");

      media.appendChild(
        createWishlistGalleryMedia(src, product?.title || "", {
          eager: index === initialIndex,
          carousel,
        })
      );
      carousel.appendChild(media);

      const dotButton = document.createElement("button");
      dotButton.type = "button";
      dotButton.className = "tap-area";
      dotButton.setAttribute(
        "aria-current",
        index === initialIndex ? "true" : "false"
      );

      const srOnly = document.createElement("span");
      srOnly.className = "sr-only";
      srOnly.textContent = `Go to item ${index + 1}`;
      dotButton.appendChild(srOnly);
      dotButton.addEventListener("click", () => {
        selectWishlistGalleryImage(wishlistDom, index);
      });
      dots.appendChild(dotButton);
    });

    if (wishlistGalleryCarouselListener) {
      carousel.removeEventListener("carousel:change", wishlistGalleryCarouselListener);
    }

    wishlistGalleryCarouselListener = (event) => {
      syncWishlistGalleryDots(wishlistDom, event.detail.index);
      preloadWishlistGalleryAdjacentImages(carousel, event.detail.index);
      refreshWishlistGalleryCarousel(carousel);
    };
    carousel.addEventListener("carousel:change", wishlistGalleryCarouselListener);

    requestAnimationFrame(() => {
      preloadWishlistGalleryAdjacentImages(carousel, initialIndex);

      if (typeof carousel.select === "function") {
        carousel.select(initialIndex, { instant: true });
      }

      syncWishlistGalleryDots(wishlistDom, initialIndex);
      refreshWishlistGalleryCarousel(carousel);

      if (wishlistDom.classList.contains("show")) {
        refreshWishlistGalleryAfterShow(wishlistDom);
      }
    });
  }

  function resetWishlistProductGallery(wishlistDom) {
    const { carousel, dots } = getWishlistGalleryElements(wishlistDom);
    if (carousel) carousel.innerHTML = "";
    if (dots) dots.innerHTML = "";
    syncWishlistGalleryArrows(wishlistDom);
  }

  async function updateWishlistProductUI(wishlistDom, product, selectedIndex = 0) {
    wishlistDom.querySelector(".product-title").innerHTML = product?.title || "";
    await buildWishlistProductGallery(wishlistDom, product, selectedIndex);
  }

  async function getWishlistSwatchData(productHandle) {
    try {
      const response = await fetch(
        `/products/${productHandle}?view=wishlist-swatch-data`
      );
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      console.error("Error fetching wishlist swatch data:", error);
      return null;
    }
  }
  
  async function getProductById(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      const product = await response.json();
      return product;
    } catch (error) {
      console.error("Error fetching product:", error);
    }
  }
  
  async function touchOrClickEvent(event) {
    if (event.target.classList.contains("button-wishlish-click")) {
      loadingFadeIn();
      if (globalListArray.length < 1) {
        createWishlist(
          document.querySelector(
            ".existing-wishlist-select-add-form input.new-wishlist-name"
          ),
          "My Wishlist",
          document.querySelector(".existing-wishlist-select"),
          true,
          false
        );
      }
  
      let wishlistDom = document.querySelector(".wishlist-variant");
      let productHandle = event.target.getAttribute("data-product-handle");
      const [product, swatchData] = await Promise.all([
        getProductById(productHandle),
        getWishlistSwatchData(productHandle),
      ]);

      wishlistDom.querySelector(".options-wrapper").innerHTML = "";
      wishlistDom.querySelector(".existing-wishlist-select").innerHTML = "";
      resetWishlistProductGallery(wishlistDom);

      wishlistCurrentSwatchData = swatchData;
      wishlistDom.querySelector(".product-title").innerHTML = product?.title || "";

      fadeIn();
      document.documentElement.classList.add("no-scroll");
      wishlistDom.classList.add("show");

      await updateWishlistProductUI(wishlistDom, product);
      refreshWishlistGalleryAfterShow(wishlistDom);
      buildWishlistVariantPicker(
        product,
        wishlistDom.querySelector(".options-wrapper"),
        swatchData
      );
      getAllExistingWishlistItems(
        wishlistDom.querySelector(".existing-wishlist-select")
      );
      resetWishlistAddForm(wishlistDom);

      loadingFadeOut();
    }
  }
  
  function isTouchDevice() {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }
  
  function detectDeviceType() {
    if (!isTouchDevice()) {
      return false;
    }
  
    const userAgent = navigator.userAgent.toLowerCase();
    if (/iphone/.test(userAgent)) {
      return true;
    } else if (
      /ipad/.test(userAgent) ||
      (navigator.maxTouchPoints > 1 && /macintosh/.test(userAgent))
    ) {
      return true;
    } else if (/android/.test(userAgent)) {
      return true;
    } else if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
      return true;
    } else {
      return false;
    }
  }
  
  document.body.addEventListener("touchstart", function (event) {
    if (detectDeviceType()) {
      checkAndInvokeSwymCallbacks();
      touchOrClickEvent(event);
    }
  });
  
  document.body.addEventListener("click", function (event) {
    if (!detectDeviceType()) {
      checkAndInvokeSwymCallbacks();
      touchOrClickEvent(event);
    }
  });
  